<template>
  <div class="left-board-box">
    <div class="select-wrapper">
      <div
        class="xm-btn btn-list"
        :class="currentTab == 'components' ? 'active' : ''"
        @click="handleClickTabs('components')"
      >
        题型选择
      </div>
      <div
        class="xm-btn btn-outline"
        :class="currentTab == 'outline' ? 'active' : ''"
        @click="handleClickTabs('outline')"
      >
        问卷大纲
      </div>
    </div>
    <div class="flex-row align-center basic-operate__box" v-show="currentTab === 'outline'">
      <el-input style="margin-right: 10px" placeholder="搜索题目内容" v-model="titleName" clearable @input="getOutline">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <i class="el-icon-more" @click="handleClickMore"></i>
    </div>
    <div class="more-operate__box" :class="{ active: more }">
      <el-tooltip
        v-for="item in operateList"
        :key="item.icon"
        effect="dark"
        :content="item.content"
        placement="top-start"
      >
        <div slot="content">{{ item.content }}</div>
        <span class="drawing-item__primary" :class="item.type" @click="operateClick(item.type)">
          <i :class="item.icon" />
        </span>
      </el-tooltip>
    </div>
    <div v-if="currentTab === 'outline'" class="question_list_item description">
      <span
        class="node_question"
        :class="selectItem === 'description' ? 'active' : ''"
        @click="scrollToItem($event, 'description', 'dId')"
        >开始语</span
      >
    </div>
    <el-scrollbar class="left_scrollbar">
      <el-row style="height: 100%">
        <div class="components-list" v-if="currentTab === 'components'">
          <div v-for="(item, listIndex) in leftComponents" :key="listIndex">
            <div class="components-title">
              {{ item.title }}
            </div>
            <draggable
              :forceFallback="true"
              :clone="cloneComponent"
              :group="{ name: 'componentsGroup', pull: 'clone', put: false }"
              :list="item.list"
              :sort="false"
              class="components-draggable"
              draggable=".components-item"
              :force-fallback="true"
              :scroll="true"
              :scroll-sensitivity="160"
              @start="$emit('start')"
              @move="$emit('move')"
              @end="
                (obj) => {
                  $emit('end', obj)
                }
              "
            >
              <div
                v-for="(element, index) in item.list"
                :key="index"
                class="components-item"
                @click="addComponent($event, element)"
              >
                <div class="components-body">
                  <form-svg-icon :name="element.config.tagIcon" />
                  {{ element.config.label }}
                </div>
              </div>
            </draggable>
          </div>
        </div>
        <!-- 大纲 -->
        <div class="outline-list" v-else ref="outline">
          <draggable
            @start="$emit('start')"
            :animation="200"
            :disabled="more"
            :list="outlineData"
            :move="(event) => $emit('move', event)"
            class="outline-list-draggable"
            :group="{ name: 'ontline_question_group' }"
            :force-fallback="true"
            :scroll="true"
            :scroll-sensitivity="160"
            @end="onGroupItemEnd($event)"
            @change="(obj) => onDraggableChange(obj, outlineData)"
            filter=".group-handle,.placeholder_box"
          >
            <ul
              v-for="(group, groupIndex) in outlineData"
              :key="group.formItemGroupId"
              class="question_list ontline_question_group"
              :distance="1"
              :id="`outline_${group.formItemGroupId}`"
            >
              <div
                @click="scrollToItem($event, `${group.formItemGroupId}`, 'formItemGroupId')"
                class="ontline_question_group_wrap"
              >
                <!-- 题目组头部 -->
                <div
                  class="group-header text-overflow flex-row"
                  :class="selectItem === group.formItemGroupId ? 'selected' : ''"
                >
                  <span
                    class="group-handle hover_cursor_pointer"
                    @click="toggleCollapse($event, groupIndex, !group.collapsed)"
                    ><i
                      caret-id="caret-down-708"
                      class="fold-button"
                      :class="group.collapsed ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"
                    ></i>
                  </span>
                  <span
                    class="hover_cursor_pointer"
                    @click="scrollToItem($event, `${group.formItemGroupId}`, 'formItemGroupId')"
                  >
                    <i class="el-icon-folder-opened fold-button"></i>{{ group.formItemGroupName }}
                  </span>
                </div>
                <draggable
                  :disabled="more"
                  :animation="180"
                  :list="group.groupItems"
                  class="questions-list-draggable"
                  :group="{ name: 'outline-list-item', pull: true, put: true }"
                  :force-fallback="true"
                  :scroll="true"
                  :scroll-sensitivity="160"
                  @start="$emit('start')"
                  @move="$emit('move')"
                  @end="(event) => $emit('outlineEnd', event)"
                  :id="`outline_question_${group.formItemGroupId}`"
                >
                  <template v-if="group.collapsed">
                    <li
                      class="question_list_item"
                      :class="selectItem === item.id ? 'active' : ''"
                      v-for="item in group.groupItems"
                      :key="item.id"
                      :distance="1"
                      :id="`outline_question_${item.id}`"
                    >
                      <div @click="scrollToItem($event, item.id, 'dId')" class="text-overflow item-title">
                        <span v-if="!more" class="node_question">
                          <i class="el-icon-document fold-button"></i>{{ item.title }}
                        </span>
                        <el-checkbox
                          v-else
                          :checked="handleItemIds.includes(item.id)"
                          @change="selectOutlineProject($event, item)"
                          >{{ item.title }}</el-checkbox
                        >
                      </div>
                    </li>
                  </template>
                </draggable>
              </div>
            </ul>
            <div class="placeholder_box"></div>
          </draggable>
        </div>
      </el-row>
    </el-scrollbar>

    <!-- 移动、复制弹窗 -->
    <batch-rank-or-copy-dialog
      :visible.sync="rankOrCopyVisible"
      :operation-type="operationType"
      :handle-item-ids="handleItemIds"
      :outline-data="outlineData"
      @confirm="handleBatchRankOrCopyConfirm"
    />
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import FormSvgIcon from '../../SvgIcon'
import { operateList } from './constant'
import { getOutlineList } from '@/api/project/form'
import { getAllComponents } from '../GenerateForm/config'
import { groupMove } from '../../../api/project/form'
import BatchRankOrCopyDialog from './BatchRankOrCopyDialog.vue'

export default {
  name: 'LeftPanel',
  components: {
    draggable,
    FormSvgIcon,
    BatchRankOrCopyDialog
  },
  props: ['activeData', 'formConf', 'formKey', 'canDrag'],
  data() {
    return {
      currentTab: 'components',
      outlineData: [],
      titleName: '',
      more: false,
      rankOrCopyVisible: false,
      operationType: 'copy',
      operateList: operateList,
      handleItemIds: [],
      forceUpdate: 0,
      selectItem: ''
    }
  },
  computed: {
    leftComponents() {
      this.showLoading = false
      console.log('加载所有组件')
      return getAllComponents(this.formConf.type)
    }
  },
  methods: {
    cloneComponent(origin) {
      this.$emit('clone-component', origin)
    },
    addComponent(event, item) {
      event.stopPropagation
      this.$emit('add-component', item)
    },
    reset() {
      this.titleName = ''
      this.handleItemIds = []
      this.more = false
    },
    handleClickTabs(val) {
      this.currentTab = val
      if (val === 'outline') this.getOutline()
      else {
        this.reset()
      }
    },
    // 获取问卷大纲列表
    async getOutline() {
      const { formKey, titleName } = this
      const oldOutlineList = this.outlineData.map((el) => {
        return {
          formItemGroupId: el.formItemGroupId,
          collapsed: el.collapsed
        }
      })

      const { data } = await getOutlineList({ formKey, titleName })
      this.outlineData = data.map((group) => {
        const oldTarget = oldOutlineList.find((el2) => el2.formItemGroupId === group.formItemGroupId)
        return {
          ...group,
          collapsed: !!titleName || oldTarget?.collapsed || false
        }
      })
    },
    handleAddFields(val) {
      this.$emit('add-fields', val)
    },
    otherRequiredChange(val) {
      this.$emit('other-required-change', val)
    },

    scrollToItem(event, itemId, idKey) {
      this.selectItem = itemId
      if (this.more) return
      this.$emit('scroll-to', itemId, idKey)
      event.stopPropagation()
    },
    operateClick(type) {
      if (this.handleItemIds.length === 0) {
        this.$message.error('请先选择题目')
      } else {
        switch (type) {
          case 'move':
          case 'copy':
            this.operationType = type
            this.rankOrCopyVisible = true
            break
          case 'delete':
            this.$confirm('删除后，对应题目的答卷数据也将一并删除且无法恢复，请确认是否删除!', '确认', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'del-model'
            }).then(() => {
              this.$emit('deleteManyProjectItem', this.handleItemIds)
            })
            break
        }
      }
    },
    selectOutlineProject(status, project) {
      if (status) this.handleItemIds.push(project.id)
      else {
        const filterData = this.handleItemIds.filter((id) => id !== project.id)
        this.$set(this, 'handleItemIds', filterData)
      }
    },
    handleClickMore() {
      this.more = !this.more
      this.handleItemIds = []
    },
    toggleCollapse(event, groupIndex, status) {
      event.stopPropagation()

      this.$set(this.outlineData[groupIndex], 'collapsed', status)
    },
    async onGroupItemEnd(groupObj) {
      await this.$nextTick()
      let { newIndex, oldIndex, clone } = groupObj
      // 这里改成，如果newIndex大于数组的长度，就放到最后一个，因为他这里有bug，你往下再脱一下，他那个index就加一了
      if (newIndex > this.outlineData.length - 1) {
        newIndex = this.outlineData.length - 1
      }
      const step = newIndex - oldIndex
      const groupId = clone.id.replace('outline_', '')
      // 检查是否存在数据丢失情况
      await groupMove({ step, handleFormItemGroupId: groupId, formKey: this.formKey })
      const exists = this.outlineData.some((group) => group.formItemGroupId === groupId)
      if (!exists) {
        console.log('数据丢失，重新获取')
        await this.getOutline()
      }
      this.$parent.queryProjectItems()
    },
    onDraggableChange(evt) {
      // 如果元素被删除（拖出列表），判断是否需要恢复
      // if (evt.removed) this.restoreItem(evt.removed.element)
    },
    restoreItem(item) {
      // 检查数据是否真的丢失
      const exists = this.outlineData.some((group) => group.formItemGroupId === item.formItemGroupId)
      if (!exists) {
        console.log('数据丢失，重新获取')
        this.getOutline()
      }
    },
    // 复制/移动操作后的回调
    handleBatchRankOrCopyConfirm($event) {
      const { formItemGroupId } = $event
      const target = this.outlineData.find((item) => item.formItemGroupId === formItemGroupId)
      if (target) target.collapsed = true
      this.getOutline()
      this.$parent.queryProjectItems()
    }
  }
}
</script>
<style lang="scss">
@import '../../../assets/styles/form/home.scss';
</style>
<style lang="scss" scoped>
::v-deep {
  .el-tabs__nav {
    // width: 260px;
    display: flex;
  }
  .el-tabs__item {
    flex: 1;
    text-align: center; /* 中心对齐文本 */
  }
  .basic-operate__box {
    padding: 10px 10px 5px;
  }
  .more-operate__box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 0;
    background-color: #f8f8f8;
    z-index: 100;
    transition: all 0.1s ease-in;
    overflow: hidden;
    &.active {
      height: 32px;
    }
    .drawing-item__primary {
      display: inline-block;
      margin-left: 10px;
      width: 22px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      border-radius: 50%;
      font-size: 12px;
      border: 1px solid;
      cursor: pointer;
      border-color: #1890ff;
      color: #1890ff;
      background: #fff;
      &:hover {
        background: #1890ff;
        color: #fff;
      }
    }
    .delete {
      border-color: #f56c6c;
      color: #f56c6c;
      background: #fff;
      &:hover {
        background: #f56c6c;
        color: #fff;
      }
    }
  }
  .el-checkbox {
    display: flex;
    align-items: center;
    .el-checkbox__input {
      line-height: 12px;
    }
    .el-checkbox__label {
      display: inline-block;
      color: #303133;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      cursor: pointer;
      padding: 0 12px 0 4px;
      font-size: 12px;
    }
  }
}
.group-header {
  font-size: 14px;
  color: #303133;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  &.selected {
    background: #f4f8ff;
    .fold-button,
    .hover_cursor_pointer {
      color: #2672ff;
    }
  }
}
.fold-button {
  color: #c0c4cc;
  margin-right: 4px;
}
.select-wrapper {
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  z-index: 99;
  background-color: #fff;

  .xm-btn {
    cursor: pointer;
    height: 36px;
    line-height: 36px;
    text-align: center;
    width: 50%;
    box-sizing: border-box;
    background-color: #f7f8fb;
    font-size: 14px;
    color: #606266;
    &.active {
      border: none;
      color: #409eff;
      background-color: #fff;
    }
  }
}
.question_list_item {
  padding-left: 24px;
  height: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  width: 100%;
  .item-title {
    height: 32px;
    line-height: 32px;
    width: 100%;
  }
  &.active {
    background: #f4f8ff;
    .node_question,
    .fold-button {
      color: #2672ff;
    }
  }
  &.description {
    padding-left: 14px;
    padding-top: 5px;
    height: 28px;
    line-height: 28px;
    .node_question {
      color: #939393;
      &.active {
        color: #2672ff;
      }
    }
  }
  .node_question {
    display: inline-block;
    color: #303133;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    cursor: pointer;
    padding: 0 12px 0 4px;
    font-size: 12px;
  }
}
</style>
